import { Component, Input } from '@angular/core';
import { TaskService } from '../services/task.service';



@Component({
  selector: 'app-task',
  templateUrl: './task.component.html'
})
export class TaskComponent {
  @Input() visitID: number;

  constructor(public service: TaskService) {

  }

  ngOnInit() {
    this.service.visitID = this.visitID;
  }


}
